//https://stackoverflow.com/questions/73296791/how-to-upload-an-image-using-redux-toolkit-query
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {LavoratoreRecord} from "@commons/mapping/LavoratoreRecord";
import {useUploadMutation} from "@commons/features/lavoratore/fotoLavoratore.api";
import React, {useState} from "react";
import {FileDropZone} from "../../PVA/comps/FileDropZone";

interface FormValues {
    picture: FileList;
    //image: File;
}

const UploadFotoLavoratore: React.FC<{ resource: LavoratoreRecord, refetch: () => void }> = ({resource, refetch}) => {
    //const [selectedImage, setSelectedImage] = useState<File | null>(null);
    const [selectedImage, setSelectedImage] = useState<File[]>([]);

    const [uploadPhoto, {isError, error, data}] = useUploadMutation();
    const {register, handleSubmit,} = useForm<FormValues>();
    const methods = useForm<FormValues>();
    const onSubmit: SubmitHandler<FormValues> = async (data) => {
        const formData = new FormData();
        /*for (let i = 0; i < data.picture.length; i++) {
            formData.append("file", data.picture[i]);
        }*/

        //If you only need to sumbit one image you can set one image instead of the loop.
        // formData.set('image', images[0])
        formData.append("file", selectedImage[0]);

        uploadPhoto({formData, codiceFiscale: resource.codiceFiscale, idAzienda: resource.idAziendaMaster}).then(() => {
            refetch();
        });
    };

    return (
        <>
            <FormProvider {...methods} >
                <form onSubmit={handleSubmit(onSubmit)}>
                    {/*<input
                        type="file"
                        accept="image/*"
                        {...register("picture")}

                        onChange={(event) => {
                            if (event.target.files) {
                                console.log(event.target.files[0]);
                                setSelectedImage(event.target.files[0]);
                            } else
                                setSelectedImage(null);
                        }
                        }
                    />

                    {selectedImage && (
                        <div>
                            <img alt="not found" width={"250px"} src={URL.createObjectURL(selectedImage)}/>
                            <br/>
                            <button onClick={() => setSelectedImage(null)}>Remove</button>
                        </div>
                    )}*/}
                    <div className="w-2/3">
                        <FileDropZone droppedFiles={selectedImage} setDroppedFiles={setSelectedImage} accept="image/*"
                                      preview={<>{selectedImage.length > 0 && selectedImage[0] &&
                                          <img alt="not found" width="250px" src={selectedImage[0] ? URL.createObjectURL(selectedImage[0]) : undefined}/>}</>}
                                      btnText="Carica foto"
                        />

                        {/*{selectedImage.length > 0 &&
                            <button type="submit"
                                    className="mt-4 inline-flex justify-center rounded-md border border-transparent bg-blue-600 py-2 px-4 text-sm font-medium text-white shadow-sm
                                                    hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50">
                                <ArrowUpOnSquareIcon className="h-5 w-5"/><span>&nbsp;Carica foto</span>
                            </button>
                        }*/}

                    </div>
                </form>
            </FormProvider>
        </>
    );
};
export default UploadFotoLavoratore;